import ItemList from '../item-list/item-list.component';
import styles from './sub-menu.module.css';
import PromotedItem from '../promoted-item/promoted-item.component';
import { NavigationNode } from '~/lib/data-contract/auto-generated/api-model';
import clsx from 'clsx';
import React, { memo } from 'react';
import { CMSLink } from '~/shared/components';

type Props = {
    menuContent?: NavigationNode | null;
    isSelected?: boolean;
    onMenuClick?: (item: NavigationNode | null) => void;
};

const SubMenu = memo(({ menuContent, isSelected, onMenuClick }: Props) => {
    return (
        <div
            className={clsx(styles.root, {
                [styles.isSelected]: isSelected,
            })}
        >
            <div className={styles.subListSection}>
                {menuContent?.children?.map((subMenu, index) => (
                    <div
                        key={`${index}-${subMenu.link?.id ?? ''}`}
                        className={styles.subListWrapper}
                    >
                        <CMSLink
                            href={subMenu.link?.url}
                            className={clsx(
                                styles.subListHeadline,
                                'hover-effect-underline-center'
                            )}
                        >
                            {subMenu.link?.title}
                        </CMSLink>
                        <ItemList
                            items={subMenu.children || []}
                            isSubList
                            onMenuClick={onMenuClick}
                        />
                    </div>
                ))}
            </div>
            {menuContent?.promotedChildren?.length ? (
                <div className={styles.subListPromoted}>
                    {menuContent.promotedChildren.map((child) => (
                        <PromotedItem key={child.link?.id} item={child} />
                    ))}
                </div>
            ) : null}
        </div>
    );
});

SubMenu.displayName = 'SubMenu';
export default SubMenu;
